import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from '../../../../service/autenticacao/auth.service';
import { LaiFormFactory } from '../../../../service/lai/lai-form-factory.service';
import { LaiService } from '../../../../service/lai/lai.service';
import { ResponseHandler } from '../../../../entity/ResponseHandlerDTO';
import { ARQUIVOS_PERMITIDOS } from '../../../../tools/Files';
import {
  OK_PROTOCOLO_MANIFESTACAO_CODIGO,
  OK_PROTOCOLO_RASCUNHO_MANIFESTACAO_CODIGO
} from '../../../../tools/Mensagens';
import { PAGINA_HOME_USUARIO_INTERNO } from '../../../../tools/URL';
import { LaiBaseComponent } from '../common/lai-base.component';

@Component({
  selector: 'app-lai-operador',
  templateUrl: './lai-operador.component.html',
  styleUrls: ['../lai.component.css', './lai-operador.component.css']
})
export class LaiOperadorComponent extends LaiBaseComponent implements OnChanges {
  @Input() nomeManifestante: string;
  @Input() emailManifestante: string;
  @Input() cpfManifestante: string;
  @Input() dataNascimentoManifestante: string;
  @Input() prioridadePessoaIdosaManifestante: boolean = false;
  @Input() demandaRecebida: string;
  @Input() lai: any;
  @Input() status!: number;

  enviando = false;
  carregandoArquivos = false;
  readonly = false;
  private arquivosPendentes = 0;
  readonly extensoesPermitidas = ['pdf', 'jpeg', 'jpg', 'png', 'zip', 'm4a', 'mp3', 'mp4'];
  readonly tamanhoMaximoArquivo = 10 * 1024 * 1024;

  constructor(
    auth: AuthService,
    factory: LaiFormFactory,
    private service: LaiService,
    private router: Router
  ) {
    super(auth, factory);
    this.liberarDadosRequerenteParaOperador();
    this.form.patchValue({
      nomeUsuarioLogado: '',
      emailUsuarioLogado: '',
      cpfUsuarioLogado: '',
      dataNascimentoUsuario: '',
      emailResposta: '',
      username: this.getUsernameOperador()
    }, { emitEvent: false });
  }

  ngOnInit() {
    super.ngOnInit();
    this.liberarDadosRequerenteParaOperador();
    if (!this.lai) {
      this.form.patchValue({
        nomeUsuarioLogado: '',
        emailUsuarioLogado: '',
        cpfUsuarioLogado: '',
        dataNascimentoUsuario: '',
        emailResposta: ''
      }, { emitEvent: false });
    }
    this.form.patchValue({ username: this.getUsernameOperador() }, { emitEvent: false });
    this.aplicarDadosManifestante();
    this.atualizarReadonly();
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.readonly = this.status === 1;

    if (changes['lai'] && changes['lai'].currentValue) {
      this.preencherFormularioEdicao(changes['lai'].currentValue);
    }

    if (changes['nomeManifestante']
      || changes['emailManifestante']
      || changes['cpfManifestante']
      || changes['dataNascimentoManifestante']
      || changes['prioridadePessoaIdosaManifestante']) {
      this.aplicarDadosManifestante();
    }

    this.atualizarReadonly();
  }

  submit(enviar: boolean, manifesto: { id: number; ordem: number; codigo: string }) {
    if (this.enviando) {
      return;
    }

    this.formSubmitted = true;
    this.form.markAllAsTouched();

    if (this.carregandoArquivos) {
      alert('Aguarde a conclusão da leitura dos anexos.');
      return;
    }

    if (this.form.invalid) {
      alert('Preencha os campos obrigatórios.');
      return;
    }

    this.enviando = true;
    const payload = this.criarPayload();
    const id = this.form.get('id').value;
    const request = id == null
      ? this.service.salvar(payload, enviar)
      : this.service.atualizar(id, payload, enviar);

    request.subscribe((retorno: ResponseHandler) => {
      this.enviando = false;
      this.acaoRetorno(retorno, manifesto, enviar);
    }, () => {
      this.enviando = false;
      alert('Não foi possível gravar a solicitação LAI.');
    });
  }

  preencherFormularioEdicao(data: any) {
    if (!data) {
      return;
    }

    this.liberarDadosRequerenteParaOperador();
    this.form.patchValue({
      id: data.id,
      nomeUsuarioLogado: data.nomeUsuarioLogado,
      emailUsuarioLogado: data.emailUsuarioLogado,
      cpfUsuarioLogado: data.cpfUsuarioLogado,
      dataNascimentoUsuario: data.dataNascimentoUsuario,
      prioridadePessoaIdosa: data.prioridadePessoaIdosa === true,
      username: data.username || this.getUsernameOperador(),
      titularidade: data.titularidade || 'TITULAR',
      outrosAssunto: data.outrosAssunto,
      descricaoDetalhada: data.descricaoDetalhada,
      formaRetorno: data.formaRetorno || 'EMAIL',
      emailResposta: data.emailResposta || data.emailUsuarioLogado
    }, { emitEvent: false });

    this.tematicasArray.clear();
    (data.tematicas || []).forEach(tematica => {
      this.tematicasArray.push(new FormGroup({
        codigo: new FormControl(tematica.codigo),
        descricao: new FormControl(tematica.descricao)
      }));
    });

    if (data.representanteLegal) {
      this.representanteLegalGroup.patchValue(data.representanteLegal, { emitEvent: false });
    }

    if (data.endereco) {
      this.enderecoGroup.patchValue(data.endereco, { emitEvent: false });
    }

    this.atualizarEstadoRepresentanteLegal();
    this.atualizarEstadoFormaRetorno();
    this.atualizarEstadoOutrosAssunto();
    this.atualizarReadonly();
  }

  get caracteresRestantes(): number {
    const valor = this.form.get('descricaoDetalhada').value || '';
    return 5000 - valor.length;
  }

  get caracteresUtilizados(): number {
    const valor = this.form.get('descricaoDetalhada').value || '';
    return valor.length;
  }

  onArquivosComplementaresChange(event: Event) {
    this.carregarArquivos(event, this.anexosArray);
  }

  onAnexosRepresentanteChange(event: Event) {
    this.carregarArquivos(event, this.anexosRepresentanteLegalArray);
  }

  private aplicarDadosManifestante() {
    const patch: any = {};

    if (this.nomeManifestante !== null && this.nomeManifestante !== undefined) {
      patch.nomeUsuarioLogado = this.nomeManifestante;
    }

    if (this.emailManifestante !== null && this.emailManifestante !== undefined) {
      patch.emailUsuarioLogado = this.emailManifestante;
      patch.emailResposta = this.form.get('emailResposta').value || this.emailManifestante;
    }

    if (this.cpfManifestante !== null && this.cpfManifestante !== undefined) {
      patch.cpfUsuarioLogado = this.cpfManifestante;
    }

    if (this.dataNascimentoManifestante !== null && this.dataNascimentoManifestante !== undefined) {
      patch.dataNascimentoUsuario = this.dataNascimentoManifestante;
    }

    if (this.prioridadePessoaIdosaManifestante !== null && this.prioridadePessoaIdosaManifestante !== undefined) {
      patch.prioridadePessoaIdosa = this.prioridadePessoaIdosaManifestante === true;
    }

    this.form.patchValue(patch, { emitEvent: false });
  }

  private liberarDadosRequerenteParaOperador() {
    ['nomeUsuarioLogado', 'emailUsuarioLogado', 'cpfUsuarioLogado', 'dataNascimentoUsuario'].forEach(campo => {
      const controle = this.form.get(campo);
      if (controle) {
        controle.enable({ emitEvent: false });
      }
    });
  }

  private atualizarReadonly() {
    this.readonly = this.status === 1;
  }

  private getUsernameOperador(): string {
    const auth: any = this.authService;
    return (auth.usuarioDTO && auth.usuarioDTO.username)
      || (auth.usuarioLogado && auth.usuarioLogado.username)
      || (auth.usuarioLogado && auth.usuarioLogado.nome)
      || '';
  }

  private carregarArquivos(event: Event, destino) {
    const input = event.target as HTMLInputElement;
    const arquivos = input.files ? Array.from(input.files) : [];
    destino.clear();
    destino.markAsTouched();
    destino.updateValueAndValidity();

    arquivos.forEach((arquivo: File) => {
      if (!this.arquivoValido(arquivo)) {
        return;
      }

      const reader = new FileReader();
      this.iniciarLeituraArquivo();
      reader.onload = () => {
        const conteudo = String(reader.result || '').split(',')[1] || '';
        destino.push(this.criarArquivoControl(arquivo, conteudo));
        destino.markAsTouched();
        destino.updateValueAndValidity();
        this.finalizarLeituraArquivo();
      };
      reader.onerror = () => {
        alert('Não foi possível ler o arquivo selecionado.');
        this.finalizarLeituraArquivo();
      };
      reader.readAsDataURL(arquivo);
    });

    input.value = '';
  }

  private criarArquivoControl(arquivo: File, conteudo: string) {
    return new FormGroup({
      nomeArquivo: new FormControl(`${this.normalizarNomeArquivo(arquivo.name)}/type=${arquivo.type || 'application/octet-stream'}`),
      conteudo: new FormControl(conteudo)
    });
  }

  private arquivoValido(arquivo: File): boolean {
    const partesNome = arquivo.name.split('.');
    const extensao = partesNome.length ? partesNome[partesNome.length - 1].toLowerCase() : '';

    if (this.extensoesPermitidas.indexOf(extensao) < 0) {
      alert('Tipo de arquivo não permitido.');
      return false;
    }

    if (arquivo.type && ARQUIVOS_PERMITIDOS.indexOf(arquivo.type) < 0) {
      alert('Tipo de arquivo não permitido.');
      return false;
    }

    if (arquivo.size > this.tamanhoMaximoArquivo) {
      alert('Tamanho máximo de arquivo permitido: 10MB.');
      return false;
    }

    return true;
  }

  private iniciarLeituraArquivo() {
    this.arquivosPendentes++;
    this.carregandoArquivos = true;
  }

  private finalizarLeituraArquivo() {
    this.arquivosPendentes = Math.max(0, this.arquivosPendentes - 1);
    this.carregandoArquivos = this.arquivosPendentes > 0;
  }

  private normalizarNomeArquivo(nome: string): string {
    return (nome || '').replace(/[\/\\]/g, '-').trim();
  }

  private acaoRetorno(retorno: ResponseHandler, manifesto: {
    id: number;
    ordem: number;
    codigo: string
  }, enviar: boolean) {
    if (retorno.data) {
      if (enviar) {
        alert(OK_PROTOCOLO_MANIFESTACAO_CODIGO(manifesto.codigo + retorno.data.id));
      } else {
        alert(OK_PROTOCOLO_RASCUNHO_MANIFESTACAO_CODIGO(manifesto.codigo + retorno.data.id));
      }
      this.router.navigate([PAGINA_HOME_USUARIO_INTERNO]);
    }
  }
}
